import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Button as Btn } from 'components';
import { Image, Dropdown, Popup, Grid } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './ExamLeakFileList.css';
const cx = classNames.bind(styles);

class ExamLeakFileFilter extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { handleInitFilter, filterClose, cancleCheck, executeFilter, paramData, filters, tempFilter, popupOpen, handlePopup } = this.props;

    // 구분 필터
    const leakType = [
      { 1: defineMessages(formatMessage({ id: 'ExamLeakFileList_5', defaultMessage: 'PC파일' })) },
      { 2: defineMessages(formatMessage({ id: 'ExamLeakFileList_2', defaultMessage: '인증서' })) },
      { 3: defineMessages(formatMessage({ id: 'ExamLeakFileList_3', defaultMessage: '이메일' })) }
    ];

    const serviceTemplateFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamTemplateList_1', defaultMessage: '구분' }))}
        />
        {leakType.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.leakTypeFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['leakTypeArray'] &&
                      tempFilter['leakTypeArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    let leakTypeArray =
      paramData.getIn(['filter', 'leakTypeArray']) && paramData.getIn(['filter', 'leakTypeArray']).toJS();

    if (leakTypeArray === undefined) {
      leakTypeArray = [];
    }

    const totalArrayLength = leakTypeArray.length;
    let leakTypeInfo = null;
    if (leakTypeArray.length > 0) {
      leakTypeInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'ExamTemplateList_1', defaultMessage: '구분' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {leakTypeArray.map((isServiceTemplate, index) => {
              const leakTypeArray =
                paramData.getIn(['filter', 'leakTypeArray']) && paramData.getIn(['filter', 'leakTypeArray']).toJS();

              let templateStatus = '';
              if (leakTypeArray[index] === '1') {
                templateStatus = defineMessages(formatMessage({ id: 'ExamLeakFileList_5', defaultMessage: 'PC파일' }));
              } else if (leakTypeArray[index] === '2') {
                templateStatus = defineMessages(formatMessage({ id: 'ExamLeakFileList_2', defaultMessage: '인증서' }));
              } else if (leakTypeArray[index] === '3') {
                templateStatus = defineMessages(formatMessage({ id: 'ExamLeakFileList_3', defaultMessage: '이메일' }));
              }

              const text =
                leakTypeArray[leakTypeArray.length - 1] !== leakTypeArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }

    // 툴팁 정보
    const tooltipInfo = (
      <div className={cx('tooltip-wrapper')}>
        <div className={cx('arrow')} />
        {leakTypeInfo}
      </div>
    );

    return (
      <Tooltip
        classes={{
          tooltip: 'tooltip',
          tooltipOpen: totalArrayLength > 0 ? '' : 'close'
        }}
        title={tooltipInfo}
        placement="bottom">
        <div className={cx('target-dropdown-area', totalArrayLength > 0 ? 'target-dropdown-area-border' : '')}>
          <div className={cx('dropdown-arrow-area', 'table-filter-arrow')}>
            {totalArrayLength > 0 ? (
              <div className={cx('number-box')}>{totalArrayLength}</div>
            ) : (
                <Image className={cx('dropdown-image')} src="/img/table/selectbox_number_arrow.png" />
              )}
          </div>
          <Popup
            className={cx('filter-popup')}
            trigger={
              <div className={cx('default-text', totalArrayLength > 0 ? 'filter-length' : '')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_35', defaultMessage: '필터' }))}
              </div>
            }
            open={popupOpen}
            onOpen={() => handlePopup(true)}
            onClose={() => { filterClose(), handlePopup(false) }}
            on="click"
            flowing
            position="bottom center">
            <Grid centered divided columns={1}>
              <Grid.Column textAlign="left">{serviceTemplateFilterOptions}</Grid.Column>
            </Grid>
            <Grid className={cx('bottom-options')}>
              <Grid.Column className={cx('multi-row')}>
                <div className={cx('all-check-off')} onClick={handleInitFilter}>
                  {defineMessages(formatMessage({ id: 'Target_32', defaultMessage: '모든 필터 해제' }))}
                </div>
                <div className={cx('inline-block')}>
                  <Btn className={cx('button-border', 'button')} onClick={() => { cancleCheck(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취 소' }))}
                  </Btn>
                  <Btn
                    className={cx('button-brand', 'button')}
                    // loading={editOnProgress}
                    // disabled={disableSave && (editInvalid || editOnProgress)}
                    onClick={() => { executeFilter(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_37', defaultMessage: '확 인' }))}
                  </Btn>
                </div>
              </Grid.Column>
            </Grid>
          </Popup>
        </div>
      </Tooltip>
    );
  }
}

export default injectIntl(ExamLeakFileFilter);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamLeakFileFilter.js